import SegmentSummaryColumn from './SegmentSummaryColumn';

export default SegmentSummaryColumn;
